module.exports = __webpack_public_path__ + "static/media/RI-D6-10.1-072.9acfd751.webp";